import './App.css';
import crediclubLogo from './assets/crediclubWhiteLogo.png';
import { Signup } from './components/Signup';
import React, { useEffect } from 'react';
import axios from 'axios'

function App() {

  useEffect(()=>{
    //Azure
    //Uncomment this on deployment
    axios.get('https://creditocrediclub.azurewebsites.net/flask/api').then(response => {
      
    //Local
    //Comment this on deployment
    //axios.get('http://localhost:5000/flask/api').then(response => {
      console.log("Connected", response)
    }).catch(error => {
      console.log(error)
    })

  }, [])
  return (
    <div className="container mt-4">
      <div className="col-md-6 my-auto">
        <img className="img-fluid w-100" src={crediclubLogo} alt="Crediclub Logo"/>
      </div>
      <div className="row justify-content-center d-flex">
        <div className="col-md-6">
          <Signup />
        </div>
      </div>
    </div>
  );
}

export default App;
